import $ from "jquery";
import Marquee from "../src/Marquee";

$(".marquee").each(function () {
  const marquee = new Marquee(this, {
    // speed: 2,
    // direction: "right",
    // pauseOnHover: true,
  });
});
